import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";

const STRING_PATH = "searchResults.sorting";

export interface SortOption {
  label: string;
  value: string;
}

export interface SortConfig {
  key: string;
  titlePath: string;
  clearPath: string;
  touchpoint: string;
  options: SortOption[];
  isRequired?: boolean;
}

export const getSortConfigs = (): SortConfig[] => {
  // Check if software reviews are enabled
  const areSoftwareReviewsEnabled = UserPermissions.current.hasPermission(PERMISSIONS.TOGGLE_SOFTWARE_REVIEWS);

  const bestMatchLabel = getString(`${STRING_PATH}.bestMatch.relevance`);
  const priceLowToHighLabel = getString(`${STRING_PATH}.price.lowToHigh`);
  const priceHighToLowLabel = getString(`${STRING_PATH}.price.highToLow`);
  const alphabeticAToZLabel = getString(`${STRING_PATH}.alphabetic.aToZ`);
  const alphabeticZToALabel = getString(`${STRING_PATH}.alphabetic.zToA`);
  // TODO: Uncomment when backend support is ready for views
  // const viewsHighToLowLabel = getString(`${STRING_PATH}.views.highToLow`);
  // const viewsLowToHighLabel = getString(`${STRING_PATH}.views.lowToHigh`);

  const baseConfigs: SortConfig[] = [
    {
      key: "bestMatch",
      titlePath: `${STRING_PATH}.bestMatch.title`,
      clearPath: `${STRING_PATH}.bestMatch.clear`,
      touchpoint: "sorting-best-match-option",
      options: [{ label: bestMatchLabel, value: "relevance" }],
      isRequired: true,
    },
    {
      key: "price",
      titlePath: `${STRING_PATH}.price.title`,
      clearPath: `${STRING_PATH}.price.clear`,
      touchpoint: "sorting-price-option",
      options: [
        { label: priceLowToHighLabel, value: "price.amount,asc" },
        { label: priceHighToLowLabel, value: "price.amount,desc" },
      ],
    },
    {
      key: "alphabetic",
      titlePath: `${STRING_PATH}.alphabetic.title`,
      clearPath: `${STRING_PATH}.alphabetic.clear`,
      touchpoint: "sorting-name-option",
      options: [
        { label: alphabeticAToZLabel, value: "name,asc" },
        { label: alphabeticZToALabel, value: "name,desc" },
      ],
    },
  ];

  // Add ratings filter if software reviews are enabled
  if (areSoftwareReviewsEnabled) {
    const ratingsHighToLowLabel = getString(`${STRING_PATH}.ratings.highToLow`);
    const ratingsLowToHighLabel = getString(`${STRING_PATH}.ratings.lowToHigh`);

    baseConfigs.push({
      key: "ratings",
      titlePath: `${STRING_PATH}.ratings.title`,
      clearPath: `${STRING_PATH}.ratings.clear`,
      touchpoint: "sorting-ratings-option",
      options: [
        { label: ratingsHighToLowLabel, value: "ratings,desc" },
        { label: ratingsLowToHighLabel, value: "ratings,asc" },
      ],
    });
  }

  // TODO: Uncomment when backend support is ready for views
  // if (areViewsEnabled) {
  //   baseConfigs.push({
  //     key: "views",
  //     titlePath: `${STRING_PATH}.views.title`,
  //     clearPath: `${STRING_PATH}.views.clear`,
  //     touchpoint: "sorting-views-option",
  //     options: [
  //       { label: viewsHighToLowLabel, value: "views,desc" },
  //       { label: viewsLowToHighLabel, value: "views,asc" },
  //     ],
  //   });
  // }

  return baseConfigs;
};
